
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#ffffff",
        "d": "M844.544 149.333333l-200 202.666667 200 202.666667H256v341.333333H192V149.333333h652.544z m-153.088 64H266.666667v277.333334h424.789333l-136.832-138.666667 136.832-138.666667z"
      }
    }
  ]
})
    }
  